import { useState } from 'react';

import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { keepPreviousData } from '@tanstack/react-query';

import { useGetCourseInstructorPool } from 'api/hooks/private/courses/GetCourseInstructorPool';
import { Instructor } from 'api/hooks/private/users/instructors/GetInstructors';

const columns: GridColDef<Instructor>[] = [
  {
    field: 'last_name',
    type: 'string',
    headerName: 'Last Name',
    minWidth: 150,
    valueGetter: (_value, row) => row.user?.last_name,
  },
  {
    field: 'first_time',
    type: 'string',
    headerName: 'First Name',
    minWidth: 150,
    valueGetter: (_value, row) => row.user?.first_name,
  },
];

export interface CourseInstructorListProps {
  courseId: string;
}

export function CourseInstructorList({ courseId }: CourseInstructorListProps) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    pageSize: 25,
    page: 0,
  });

  // get course sections
  const instructors = useGetCourseInstructorPool({
    variables: {
      courseId: courseId,
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
    },
    // use previous data as placeholder to maintain a stable
    // reference while fetching the next page so the datagrid
    // doesn't reset the pagination model
    placeholderData: keepPreviousData,
    enabled: !!courseId,
  });

  return (
    <DataGrid
      loading={instructors.isFetching}
      columns={columns}
      rows={instructors.data?.rows}
      getRowId={(row) => row.user_id}
      paginationMode="server"
      rowCount={instructors.data?.count ?? 0}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      disableColumnFilter
      disableColumnSorting
    />
  );
}

export default CourseInstructorList;
